import { Outlet } from "react-router-dom";
import Navbar from "./Navbar";

export default function Layout() {
  return (
    <div className="bg-white">
      <Navbar />
      <main className="md:pl-28">
        <Outlet />
      </main>
    </div>
  );
}
